import { v4 as uuid } from 'uuid'

export const UUID = (): string => uuid()
